import { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import AudioTable from "./AudioTable";
import useAxios from "axios-hooks";
import DeleteAudioModal from "./DeleteAudioModal";
import { Spinner, Toggle } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";

const AudioList = () => {
    const [selectedAudioId, setSelectedAudioId] = useState(undefined);
    const [selectedAudioTitle, setSelectedAudioTitle] = useState("");
    const history = useHistory();
    let { url } = useRouteMatch();

    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: audios, loading }, refetch] = useAxios("resources/audio/all");

    if (loading)
        return <Spinner className="absolute-center" label="Loading Audio..." />;

    return (
        <>
            <AudioTable
                audios={audios && audios.length > 0 ? audios.sort((a, b) => b.audioid - a.audioid) : []}
                setSelectedAudioId={setSelectedAudioId}
                setSelectedAudioTitle={setSelectedAudioTitle}
                selectedAudioId={selectedAudioId}
                createOnClick={() => history.push(`${url}/wizard`)}
                deleteOnClick={(id, title) => {
                    setSelectedAudioId(id);
                    setSelectedAudioTitle(title || "");
                    toggleDeleteModal();
                }}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                refetch={refetch}
                loading={loading}
            />
            <DeleteAudioModal
                audioId={selectedAudioId}
                audioTitle={selectedAudioTitle}
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
            />
        </>
    );
};

export default AudioList;
